import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import balanceImg from "../../assets/images/account-balance-img.svg";
import withdrawImg from "../../assets/images/account-withdraw-img.svg";
import ShoppingAPI from "../../store/shopping/shopping.api";

const Withdrawal = () => {
    const [transactions, setTransactions] = useState(false);
    const [balance, setBalance] = useState({
        amount: 0.0,
        currency: "MYR",
    });

    useEffect(() => {
        ShoppingAPI.GetUserTransactions("")
            .then((x) => {
                setTransactions(x.data);
                let data = x.data
                    .filter(
                        (x) =>
                            x.payoutStatus === undefined ||
                            x.payoutStatus === "Initiated"
                    )
                    .map((x) => x.netAmount)
                    .reduce((partial_sum, a) => partial_sum + a, 0);
                setBalance({
                    amount: data,
                    currency:
                        x.data.length > 0
                            ? x.data[0].currency.toUpperCase()
                            : "MYR",
                });
                //
            })
            .catch((x) => {
                setBalance({
                    amount: 0.0,
                    currency: "MYR",
                });
            });
    }, []);

    return (
        <div>
            <div className="flex flex-col sm:flex-row gap-4 mb-5">
                <div className="flex items-center justify-between p-4 w-full md:max-w-[266px] rounded-md border border-black-10r">
                    <div className="">
                        <p className="text-sm font-medium text-black-50 mb-1.5">
                            Total Balance in account
                        </p>
                        <p className="text-xl font-bold text-ebony-color">
                            {balance.currency + " " + balance.amount.toFixed(2)}
                        </p>
                    </div>
                    <div className="">
                        <img src={balanceImg} alt="" />
                    </div>
                </div>

                <div className="flex items-center justify-between p-4 w-full md:max-w-[266px] rounded-md border border-black-10r">
                    <div className="">
                        <p className="text-sm font-medium text-black-50 mb-1.5">
                            Total Balance in account
                        </p>
                        <p className="text-xl font-bold text-ebony-color mb-2">
                            {balance.currency + " " + balance.amount.toFixed(2)}
                        </p>
                        <Link
                            to="/page/account/withdraw-balance"
                            className="text-sm font-medium text-orange-color"
                        >
                            Withdraw
                        </Link>
                    </div>
                    <div className="">
                        <img src={withdrawImg} alt="" />
                    </div>
                </div>
            </div>

            {/* TABLE  */}
            <div className="">
                <div className="overflow-x-auto relative bg-white">
                    <table className="w-full text-left ">
                        <thead className="text-sm font-medium text-black-50 capitalize border-b border-black-10">
                            <tr>
                                <th
                                    scope="col"
                                    className="py-3 px-6 whitespace-nowrap"
                                >
                                    Date
                                </th>
                                <th
                                    scope="col"
                                    className="py-3 px-6 whitespace-nowrap"
                                >
                                    Transaction ID
                                </th>
                                <th
                                    scope="col"
                                    className="py-3 px-6 whitespace-nowrap"
                                >
                                    Amount
                                </th>
                                <th
                                    scope="col"
                                    className="py-3 px-6 whitespace-nowrap"
                                >
                                    Status
                                </th>
                                <th
                                    scope="col"
                                    className="py-3 px-6 whitespace-nowrap"
                                >
                                    Type
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-sm text-black-60">
                            {transactions &&
                                transactions.map((details) => {
                                    return (
                                        <tr
                                            key={details.id}
                                            className="border-b border-black-10"
                                        >
                                            <th
                                                scope="row"
                                                className="pt-[18px] pb-5 px-6 text-ebony-color font-normal whitespace-nowrap"
                                            >
                                                {moment(
                                                    details.dateCreated
                                                ).format("lll")}
                                            </th>
                                            <td className="pt-[18px] pb-5 px-6 whitespace-nowrap">
                                                {details.chargeId}
                                            </td>
                                            <td className="pt-[18px] pb-5 px-6 whitespace-nowrap">
                                                {details.currency}{" "}
                                                {details.netAmount}
                                            </td>
                                            <td className="pt-[18px] pb-5 px-6 whitespace-nowrap">
                                                {details.payoutStatus ===
                                                "Initiated"
                                                    ? "New"
                                                    : details.payoutStatus}
                                            </td>
                                            <td className="pt-[18px] pb-5 px-6 whitespace-nowrap">
                                                {details.type}
                                            </td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Withdrawal;
